import { useState, useEffect } from 'react';
import ConfirmModal from './ConfirmModal';
import HistoryTimeline from './HistoryTimeline';
import { APIClient } from "../helpers/api_helper";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form,
  Input, Row, Segmented, Space
} from 'antd';
const api = new APIClient();


const ProjectTypeDrawer = (props) => {
  const [form] = Form.useForm();
  const [activeDrawerTab, setActiveDrawerTab] = useState('data');
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    setActiveDrawerTab('data');
    if (props.id) {
      try {
        api.get(`/api/project_types/${props.id}/`, {})
          .then(resp => {
            setData(resp);
            form.setFieldsValue(resp);
          });
      } catch (error) {
        console.error(error);
      }
    } else {
      form.resetFields();
      setData(null);
    }
  }, [props.isOpen, props.id]);


  const handleCancel = () => {
    form.resetFields();
    props.onCancel()
  }

  const handleConfirmedDelete = () => {
    api.delete(`/api/project_types/${props.id}/`, {}, {successMsg: `Vrsta projekta ${props.id}: ${data.title} je bila izbrisana`})
      .then(resp => {
        props.onDone()
        form.resetFields();
        setShowDeletionConfirmModal(false);
      })
      .catch(error => {
        console.error(error)
      })
  };

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const isEdit = props.id !== null;
        const apiCall = isEdit
            ? api.update(`/api/project_types/${props.id}/`, values)
            : api.create('/api/project_types/', values, {successMsg: `Vrsta projekta ${values.title} je bila ustvarjena`});

        apiCall.then(resp => {
            props.onDone();
            form.resetFields();
          }).catch(err => console.error('API error:', err));
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  const isCreation = props.id == null;

  return (
    <>
      <Form layout="vertical" form={form}>
        <Drawer
          title={
            <Space>
              <span>{isCreation ? "Ustvari novo vrsto projekta" : `Vrsta projekta #${props.id}`}</span>
              {!isCreation && (
                <Segmented
                  size="small"
                  value={activeDrawerTab}
                  onChange={setActiveDrawerTab}
                  options={[
                    { label: 'Podatki', value: 'data' },
                    { label: 'Zgodovina', value: 'history' },
                  ]}
                />
              )}
            </Space>
          }
          width={720}
          onClose={handleCancel}
          open={props.open}
          extra={
            activeDrawerTab === 'data' && (
              <Space>
                <Button disabled={isCreation} onClick={() => setShowDeletionConfirmModal(true)} danger><DeleteOutlined /></Button>
                <Button onClick={handleCancel}><CloseOutlined /></Button>
                <Button onClick={onSubmit} type="primary">Shrani</Button>
              </Space>
            )
          }
        >
          {activeDrawerTab === 'data' && (
            <Row>
              <Col span={24}>
                <Form.Item name="title" label='Naziv' rules={[]}>
                  <Input placeholder={'Naziv vrste projekta'} />
                </Form.Item>
              </Col>
            </Row>
          )}

          {activeDrawerTab === 'history' && (
            <HistoryTimeline model="ProjectType" objectId={props.id} />
          )}
        </Drawer>
      </Form>

      <ConfirmModal
        textComponent={<p>{`Ali res želite izbrisati vrsto projekta #${data?.id}?`}</p>}
        open={showDeletionConfirmModal}
        confirmBtnTitle='Izbriši'
        confirmBtnProps={{'danger': true}}
        onOk={() => handleConfirmedDelete()}
        onCancel={() => {
          setShowDeletionConfirmModal(false);
        }}
      />
    </>
  );
};

export default ProjectTypeDrawer;
